import { titulosApi } from "../view/titulos.service";

export const deleteTitulo = titulosApi.injectEndpoints({
  endpoints: (builder) => ({
    deleteTitulo: builder.mutation({
      query: (id) => ({
        url: `/v1/api/titulo/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Titulos", id: "LIST" }],
    }),
  }),
});

export const { useDeleteTituloMutation } = deleteTitulo;
